import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";

import { urlMainAPI, showError } from "@/global";
import { isRtoUnreachableError, RTO_UNREACHABLE_MESSAGE } from "@/components/pap/rtoErrors";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMenuVisible: false,
    showWait: false,
    token: null,
    user: null,
    system: null,
    msg: "",
    dt1: null,
    dt2: null,
    infoReport: {
      show: false,
    },
    xml: null,
    mapList: null,
    rotationScreen: false,
    reliability: {
      pgdi: false,
      a: 0,
      b: 0,
      c: 0,
      a_name: 'A',
      b_name: 'B',
      c_name: 'C',
    },
    isOnlineReady: false,
    isOnlineRunning: false,
    autonomousMode: false,
    activeModel: null,
    triggerActive: 0,
    changingStatus: 0,
    maintenance: false,
    msgBoxState: false,
    tokenMaxTime: "8",
    unitName: null,
    flowchartStructure: null,
    scenarioName: "Não informado",
    scenarioManagerAutoSelect: false,
    scenarioOutdated: false,
    canUpdateFormLoss: {},
    systemMessages: null,
    intervals: {},
    indicatorsData: {},
    monitoringGridId: null,
    fixedIndicatorsConfig: null,
    monitoringEditorMode: false,
    rtoActive: false,
    // Garante que o toast "Nao foi possivel contatar o sistema RTO" apareca
    // no maximo uma vez por sessao — o polling roda a cada 30s e ficaria
    // poluindo a tela se mostrasse sempre. Recomeca em F5/relogin.
    rtoUnreachableNotified: false,
  },
  mutations: {
    toggleMenu(state, isVisible) {
      if (!state.user) {
        state.isMenuVisible = false;
        return;
      }

      if (isVisible === undefined) {
        state.isMenuVisible = !state.isMenuVisible;
      } else {
        state.isMenuVisible = isVisible;
      }
    },
    setIsOnlineReady(state, isOnlineReady) {
      state.isOnlineReady = isOnlineReady;
    },
    setIsOnlineRunning(state, isOnlineRunning) {
      state.isOnlineRunning = isOnlineRunning;
    },
    setAutonomousMode(state, autonomousMode) {
      state.autonomousMode = autonomousMode;
    },
    setActiveModel(state, activeModel) {
      state.activeModel = activeModel;
    },
    setTriggerActive(state, triggerActive) {
      state.triggerActive = triggerActive;
    },
    setChangingStatus(state, changingStatus) {
      state.changingStatus = changingStatus;
    },
    setMaintenance(state, maintenance) {
      state.maintenance = maintenance;
    },
    setShowWait(state, showWait) {
      // console.log('showWait: ' + showWait);
      state.showWait = showWait;
    },
    setXML(state, xml) {
      state.xml = xml;
    },
    setMapList(state, list) {
      state.mapList = list;
    },
    setRotationScreen(state, rotationScreen) {
      state.rotationScreen = rotationScreen;
    },
    setMonitoringEditorMode(state, value) {
      state.monitoringEditorMode = value;
    },
    setUser(state, user) {
      state.user = user;
      if (user) {
        /* eslint-disable */
        //axios.defaults.headers.common["Authorization"] = `bearer ${token}`;
        state.isMenuVisible = true;
      } else {
        //delete axios.defaults.headers.common["Authorization"];
        state.isMenuVisible = false;
      }
    },
    setSystem(state, system) {
      // console.log('Store - System: ', system)
      state.system = system;
    },
    setToken(state, token) {
      if (token) {
        state.token = token;
        // console.log("state.token: " + state.token);
        axios.defaults.headers.common["Authorization"] = `bearer ${token}`;
      } else {
        delete axios.defaults.headers.common["Authorization"];
      }
    },
    setMsg(state, msg) {
      // if (msg) {
      state.msg = msg;
      // }
    },
    setMsg2(state, json) {
      // console.log("entrou store - json reliability - monitoramento")
      // console.log(json)
      if (json) {
        state.reliability = json;
      }
    },
    setDt1(state, json) {
      if (json) state.dt1 = json;
    },
    setDt2(state, json) {
      if (json) state.dt2 = json;
    },
    setInfoReport(state, json) {
      if (json) state.infoReport = json;
    },
    setTokenMaxTime(state, maxTime) {
      state.tokenMaxTime = maxTime;
    },
    setMsgBoxState(state, value) {
      state.msgBoxState = value;
    },
    setFlowchartStructure(state, FlowChart) {
      state.flowchartStructure = FlowChart;
    },
    setUnitName(state, unitName) {
      state.unitName = unitName;
    },
    setScenarioName(state, scenarioName) {
      state.scenarioName = scenarioName;
    },
    setScenarioManagerAutoSelect(state, value) {
      state.scenarioManagerAutoSelect = value;
    },
    setScenarioOutdated(state, value) {
      state.scenarioOutdated = value;
    },
    clear(state) {
      Object.keys(state).forEach((o) => {
        state[o] = null;
      });
    },
    setCanUpdateFormLoss(state, newData) {
      state.canUpdateFormLoss = newData;
    },
    setIndicatorsData(state, data) {
      state.indicatorsData = data;
    },
    setMonitoringGridId(state, id) {
      state.monitoringGridId = id;
    },
    setFixedIndicatorsConfig(state, config) {
      state.fixedIndicatorsConfig = config;
    },
    setRtoActive(state, isActive) {
      state.rtoActive = !!isActive;
    },
    setRtoUnreachableNotified(state, v) {
      state.rtoUnreachableNotified = !!v;
    },
    setSystemMessages(state, messages) {
      if(!state.systemMessages) {
          state.systemMessages = []
      }

      // Mantém as mensagens com categoria 'fixo' (normalmente adicionadas manualmente)
      state.systemMessages = state.systemMessages.filter(m => m.categories.indexOf('Fixo') >= 0).concat(messages)
    },
    addSystemMessage(state, message) {
        if(state.systemMessages) {
            let list = state.systemMessages.filter(m => 
                m.type != message.type
                && m.title != message.title
                && m.subtitle != message.subtitle
            );
            list.unshift(message)
            state.systemMessages = list;
        } else {
            state.systemMessages = [message]
        }
    },
  },
  actions: {
    // setShowWaitAsync({commit}, showWait){
    //   console.log('showWaitAsync: ' + showWait);
    //   commit("setShowWait", showWait)
    // },
    fetchRtoActiveState({ commit, state }) {
      if (state.user == null) return;
      // Sem permissao RTO - Configuracoes o usuario nem ve o indicador,
      // entao nao adianta bater na API: nem todo cliente tem RTO instalado.
      const perms = state.user && state.user.Permissions && state.user.Permissions.rtoconfigurar;
      if (!perms || !perms.allowed) return;
      // "RTO ATIVO" reflete o StatusOtimizador do RTO — o liga/desliga do
      // monitoramento constante de gatilhos. Fonte da verdade fica no RTO.
      return axios
        .get(`${urlMainAPI}/configurator/rto/configuracao`, { skipGlobalErrorHandler: true })
        .then((res) => {
          let data = res.data;
          if (typeof data === "string") data = data ? JSON.parse(data) : null;
          const cfg = data && data.data ? data.data : data || {};
          const raw = cfg.statusOtimizador;
          // RTO devolve "Ativo"/"Inativo" (string) ou 1/2 (número).
          const isActive =
            typeof raw === "string" ? raw.toLowerCase() === "ativo" : raw === 1;
          commit("setRtoActive", isActive);
          // RTO voltou — permite avisar novamente caso caia depois.
          if (state.rtoUnreachableNotified) commit("setRtoUnreachableNotified", false);
        })
        .catch((err) => {
          // RTO inacessivel: avisa uma vez por sessao. Demais falhas silenciosas
          // (4xx, 500 nao-conn, etc) — indicador nao deve poluir a tela.
          if (!state.rtoUnreachableNotified && isRtoUnreachableError(err)) {
            showError(RTO_UNREACHABLE_MESSAGE);
            commit("setRtoUnreachableNotified", true);
          }
        });
    },
    getOnlineModeStatus({ commit, state }) {
      const url = `${urlMainAPI}/systemStatus`;
      if (state.user != null) {
        // console.log("User: " + state.user.FullName);
        axios.get(url).then((res) => {
          if (res) {
            if (this.state.changingStatus != 0) return;
            commit("setIsOnlineReady", res.data.onlineReady);

            if (!res.data.onlineReady) commit("setIsOnlineRunning", false);
            else commit("setIsOnlineRunning", res.data.onlineActive);

                            commit("setMaintenance", res.data.maintenance);
                            commit("setActiveModel", res.data.activeModel);
                            commit("setTriggerActive", res.data.triggerActive);
                            commit("setAutonomousMode", res.data.autonomousMode);
                        }
                    })
            }
        },
        startMonitoringSystemMessages({commit, state}) {
          if(state.intervals.systemMessages) {
            clearInterval(state.intervals.systemMessages);
            state.intervals.systemMessages = undefined;
          }
    
          let systemMessagesInterval = setInterval(() => {
            axios.get(`${urlMainAPI}/getallsystemeventmessages`).then((response) => {
                commit('setSystemMessages', response.data)
            }).catch((error) => {
                console.error('>> Get All System Event Messages', error)
            });
          }, 1000 * 15);
          state.intervals.systemMessages = systemMessagesInterval
        }
    }
});
